import { render } from "./loading_animation1.vue?vue&type=template&id=0fa7b0bf&scoped=true"
import script from "./loading_animation1.vue?vue&type=script&lang=js"
export * from "./loading_animation1.vue?vue&type=script&lang=js"

import "./loading_animation1.vue?vue&type=style&index=0&id=0fa7b0bf&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa7b0bf"]])

export default __exports__